import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import CaseStudyVideoGallery from "../components/CaseStudyVideoGallery";
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";

const CASE_STUDIES_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_case_study_videos";
const PAGE_SIZE = 5;

function CaseStudyVideos() {
  const [searchParams] = useSearchParams();
  const parsedPage = Number.parseInt(searchParams.get("page"), 10);
  const page = Number.isInteger(parsedPage) && parsedPage > 0 ? parsedPage : 1;
  const [videos, setVideos] = useState([]);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);
    fetch(`${CASE_STUDIES_API}?page=${page}&limit=${PAGE_SIZE}`)
      .then((response) => {
        if (!response.ok) throw new Error("Unable to load case studies");
        return response.json();
      })
      .then((json) => {
        setVideos(Array.isArray(json?.data) ? json.data : []);
        setLastPage(Number(json?.pagination?.last_page) || 1);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [page]);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";
  }, []);

  return (
    <div>
      <Preloader />
      <div className="breadcrumb-section breadcrumb-compact bg-img jarallax" style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}>
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2>Case Study Videos</h2>
            <ul className="list-unstyled"><li><Link to="/">Home</Link></li><li>Case Studies</li></ul>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      <section className="case-study-section bg-white">
        <div className="divider"></div>
        <div className="container">
          <div className="section-heading text-center"><h2>Explore All Case Studies</h2></div>
          {loading ? (
            <div className="text-center py-5"><div className="spinner-border text-secondary" role="status"><span className="visually-hidden">Loading...</span></div></div>
          ) : error ? (
            <p className="text-center py-5">Case study videos could not be loaded. Please try again.</p>
          ) : videos.length > 0 ? (
            <CaseStudyVideoGallery videos={videos} />
          ) : (
            <p className="text-center py-5">No case study videos are available yet.</p>
          )}

          {!loading && !error && (
            <nav className="case-study-pagination" aria-label="Case study video pages">
              {page > 1 ? (
                <Link to={`/case-studies?page=${page - 1}`} className="btn btn-primary">Previous</Link>
              ) : (
                <button type="button" className="btn btn-primary" disabled>Previous</button>
              )}
              <span>Page {Math.min(page, lastPage)} of {lastPage}</span>
              {page < lastPage ? (
                <Link to={`/case-studies?page=${page + 1}`} className="btn btn-primary">Next</Link>
              ) : (
                <button type="button" className="btn btn-primary" disabled>Next</button>
              )}
            </nav>
          )}
        </div>
        <div className="divider"></div>
      </section>
      <ScrollToTop />
    </div>
  );
}

export default CaseStudyVideos;
